<template>
  <div>
    <div>{{ $t('detail.commande.commercial.contact') }} {{ commercial.nom }}</div>
    <div>{{ $t('detail.commande.commercial.email') }} {{ commercial.email }}
      <template v-if="commercial.phone">
        - {{ $t('detail.commande.commercial.tel') }} {{ commercial.phone }}
      </template>
    </div>
    <div>{{ $t('detail.commande.commercial.reference') }}
      &nbsp;{{ referenceClient }}</div>
    <div>{{ $t('detail.commande.folderCode') }}
      &nbsp;{{ codeDossier }}</div>
  </div>
</template>

<script>
export default {
  props: {
    commercial: {
      type: Object,
      required: true,
    },
    referenceClient: {
      type: String,
      required: false,
    },
    codeDossier: {
      type: String,
      required: false,
    },
  },
};
</script>
